import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";

const ExecutionSettingsResponseSchema = z.object({
  enabled: z.boolean(),
  disabledAt: z.string().datetime().optional(),
  disabledBy: z.string().optional()
});

/**
 * ZExecutionGuard - API schemas for the AI kill switch
 */
export const ZExecutionGuard = {
  /**
   * GET /api/execution-guard/settings
   * Get the current org-level execution settings (kill switch state).
   */
  GetSettings: {
    method: "GET" as const,
    path: "/api/execution-guard/settings",
    Response: ApiSuccessSchema(ExecutionSettingsResponseSchema)
  },

  /**
   * PATCH /api/execution-guard/settings
   * Toggle the org-level AI kill switch.
   */
  UpdateSettings: {
    method: "PATCH" as const,
    path: "/api/execution-guard/settings",
    Body: z.object({
      enabled: z.boolean()
    }),
    Response: ApiSuccessSchema(ExecutionSettingsResponseSchema)
  }
} as const;
